/**
 * Created by litao on 2018/10/8.
 */
import JBoot from 'jboot-env';
import 'jboot-env/style/number-font/index.css';

import Vue from 'vue';
import './style/index.scss';
import configure from './configure/index';

// 在 main.js中导入import 'xe-utils'就好用了
import "xe-utils";
import VXETable from "vxe-table";
// import "vxe-table/lib/index.css";
Vue.use(VXETable);
let T = new JBoot(Vue, configure);
T.$vue.prototype.$formatMoney = formatMoney;
let text = '这是测试通知，Demo在main.js文件中';
function formatMoney(val) {
    val=val/100;
    val = val.toString().replace(/\$|\,/g,'');
    if(isNaN(val)) {
        val = "0";
    }
    let sign = (val == (val = Math.abs(val)));
    val = Math.floor(val*100+0.50000000001)
    let cents = val%100;
    val = Math.floor(val/100).toString();
    if(cents<10) {
        cents = "0" + cents
    }
    for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
        val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
    }

    return (((sign)?'':'-') + val + '.' + cents);
}

Vue.filter('money', function(val) {
    val=val/100;
    val = val.toString().replace(/\$|\,/g,'');
    if(isNaN(val)) {
        val = "0";
    }
    let sign = (val == (val = Math.abs(val)));
    val = Math.floor(val*100+0.50000000001);
    let cents = val%100;
    val = Math.floor(val/100).toString();
    if(cents<10) {
        cents = "0" + cents
    }
    for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
        val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
    }

    return (((sign)?'':'-') + val + '.' + cents);
})


T.$vue.prototype.$formatExportJson=function(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => {

        let keys = (j.split('.') || []).filter(item => item),
            obj = Object.assign({}, v);

        for (let i = 0; i < keys.length; i++) {
            obj = obj[keys[i]];
        }
        return obj;
    }))
}


T.$vue.prototype.$getExportParam = function (object) {
    if (!object) {
        return;
    }
    if (typeof object !== 'object') {
        throw new Error("参数错误！");
    }
    let str = "";
    for (let key in object) {
        if (object[key]) {
            let index = key.indexOf(":");
            if (index > -1) {
                let sum = () => {
                    let count = 0;
                    for (let str of key) {
                        if (str === ':') {
                            count++;
                        }
                    }
                    switch (count) {
                        case 1:
                            if (key.includes('GT') || key.includes('LT')) {
                                str += key.split(":")[0] + key.split(":")[1].toLocaleLowerCase() + '=' + object[key] + '&';
                            }else{
                                str += key.split(":")[0] + '=' + object[key] + '&';
                            }
                            break;
                        case 2:
                            str += key.split(":")[0] + key.split(":")[1].toLocaleLowerCase() + '=' + object[key] + '&';
                            break;
                        case 3:
                            str += key.split(":")[1] + key.split(":")[2].toLocaleLowerCase() + '=' + object[key] + '&';
                            break
                        default:
                            throw new Error("冒号异常！");
                    }
                }
                sum();
            } else {
                str += key + '=' + object[key] + '&';
            }
        }
    }
    return str.substring(0, str.length - 1);

}

T.$vue.prototype.$toChineseBig = function (num) {
    // 将接收到的num转换为字符串
    var strNum = String(num)
    // 定义单位
    // var unit = ['拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟']
    var unit = ['十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千']
    // 结果中放一个符号，用来解决最后的零去不掉的问题
    var result = ['@']
    // 单位下标
    var unitNo = 0
    // 从后往前遍历接收到的数据，省略结束条件
    for (let i = strNum.length - 1;; i--) {
        // 调用转大写函数，将每一个数字转换成中文大写，一次放入一个到结果数组中
        result.unshift(numToChinese(strNum[i]))
        // 如果不大于0
        if (i <= 0) {
            // 结束循环
            break
        }
        // 放入一个数字，放入一个单位
        result.unshift(unit[unitNo])
        // 单位下标加1
        unitNo++
    }
    // 将结果数组转换成字符串，并使用正则替换一些关键位置，让结果符合语法
    if(num>=10 && num < 20){
        result.splice(0,1);
    }
    // return result.join('').replace(/(零[仟佰拾]){1,3}/g, '零').replace(/零{2,}/g, '零').replace(/零([万亿])/g, '$1').replace(/亿万/g, '亿').replace(/零*@/g, '')
    return result.join('').replace(/(零[千百十]){1,3}/g, '零').replace(/零{2,}/g, '零').replace(/零([万亿])/g, '$1').replace(/亿万/g, '亿').replace(/零*@/g, '') + '班'

    function numToChinese(n) {
        // var chineseBigNum = '零壹贰叁肆伍陆柒捌玖'
        var chineseBigNum = '零一二三四五六七八九'
        return chineseBigNum[n]
    }
}

//
// setTimeout(() => {
//     T.$vue.prototype.$pushText2NextVoiceNotification({
//         text: '这是一条插播消息',
//         callback (){
//             T.$vue.prototype.$notify({
//                 title: '警告',
//                 message: '这是一条插播消息',
//                 type: 'warning',
//                 offset: 60
//             });
//         }
//     });
// }, 3000);

// console.log(T);
// console.log(T.$vue.prototype.$decrypt('afa46850da10cd13b993b15bf7cfc2c34f587d83ec4603006860f300b9e2947230dddc457bc4e6b546e449ae4f448318030390538fae7ac660148657d739e68bdc7e1decda42d3672aa50fadfa0f7e1aaec3bbbe3a4385e61dfae8f24cfe458cbbf7e208e81849e7000f2a416b87bfb252481f33eade7f04b201d9dcdd'));





// WEBPACK FOOTER //
// ./src/main.js